import first from "lodash/first";
import { graphql, readInlineData } from "react-relay";

import type { helpersCheckIsMainTopicContent$key } from "~/queries/__generated__/helpersCheckIsMainTopicContent.graphql";

export const checkIsMainTopic = (
  reference_: helpersCheckIsMainTopicContent$key,
  entityId?: string,
) => {
  if (!entityId) return false;

  const content = readInlineData(
    graphql`
      fragment helpersCheckIsMainTopicContent on Content @inline {
        topics {
          entityId
        }
      }
    `,
    reference_,
  );

  // TODO: missing 20PartyCongress and HK25 logic here
  return first(content.topics)?.entityId === entityId;
};
